package com.fireavert.fire_risk.data_models

enum class RiskTableColumns(val columnName: String) {
    RISK_LEVEL("Risk Level"),
    PROPERTY_NAME("Property"),
    UNIT("Unit"),
    TAKE_ACTION("Take Action")
}